export default "__VITE_ASSET__c50a0289__"